import * as React from 'react';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { IDocument } from '../../../../../infrastructure/interfaces';
import PagePlaceholder from './PagePlaceholder';


export interface PageResultProps {
  lastDroppedItem: { type: number; data: any, accepts:string[] };
  index: number;
  document: IDocument | null;
  pagePosition: string;
  pageNumber?: number;
  isAside?: boolean;
  layout?: string | null;
}

export default class PageResult extends React.Component<PageResultProps> {

  render() {
    const {
      lastDroppedItem,
      index,
      document,
      pageNumber,
    } = this.props;

    const pagePosition = (((pageNumber != undefined) && (pageNumber % 2)) == 0) ? "left" : "right";
    let templateType = lastDroppedItem.data && lastDroppedItem.data.templateType;
    templateType = document && document.type !== 'Bulletin' ? templateType : 'type2';

    return (
      <div
        className={`${this.props.layout} ${pagePosition} crop-page-view-drop ${
          lastDroppedItem.type === placeholderTypes.Image ||
            lastDroppedItem.type === placeholderTypes.Blank ? 'crop-page-view-image-drop' : ''}
        ${lastDroppedItem.data ? 'isDropped' : ''} 
        ${templateType ? `catalog-product ${templateType}` : ''}`}
      >
        <PagePlaceholder
          index={index}
          model={lastDroppedItem}
          isEditorView={false}
          document={this.props.document}
          pageNumber={this.props.pageNumber}
          isAside={this.props.isAside}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageResult.tsx